import { theme } from './theme'

const { FONTS, COLORS, BREAKPOINTS } = theme

// eslint-disable-next-line
import { css } from 'styled-components'

export const typographyStyles = {
  headline1: css`
    @media only screen and (${BREAKPOINTS.sm}) {
      font-size: ${FONTS.sizes.xxxl};
    }
    font-size: ${FONTS.sizes.xl};
    font-family: ${FONTS.families.headlines.light};
    color: ${COLORS.secondary.darkBlue.primary};
    font-weight: ${FONTS.weights.light};
  `,
  headline2: css`
    @media only screen and (${BREAKPOINTS.sm}) {
      font-size: ${FONTS.sizes.xl};
    }
    font-family: ${FONTS.families.headlines.regular};
    font-weight: ${FONTS.weights.normal};
    color: ${COLORS.secondary.darkBlue.primary};
    font-size: ${FONTS.sizes.lg};
  `,
  headline3: css`
    font-size: ${FONTS.sizes.lg};
    font-family: ${FONTS.families.headlines.regular};
    font-weight: ${FONTS.weights.normal};
    color: ${COLORS.secondary.darkBlue.primary};
  `,
  headline4: css`
    font-size: ${FONTS.sizes.md};
    font-family: ${FONTS.families.headlines.regular};
    font-weight: ${FONTS.weights.normal};
    color: ${COLORS.secondary.darkBlue.primary};
  `,
  link: css`
    font-size: ${FONTS.sizes.sm};
    font-family: ${FONTS.families.regular};
    color: ${COLORS.primary.maerskBlue};
  `,
  button: css`
    font-size: ${FONTS.sizes.sm};
    font-family: ${FONTS.families.regular};
    color: ${COLORS.secondary.darkBlue.primary};
  `,
  paragraph1: css`
    font-size: ${FONTS.sizes.md};
    font-family: ${FONTS.families.regular};
    color: ${COLORS.secondary.darkBlue.primary};
  `,
  paragraph1Secondary: css`
    font-size: ${FONTS.sizes.md};
    font-family: ${FONTS.families.regular};
    color: ${COLORS.greys.dark};
  `,
  paragraphBold1: css`
    font-size: ${FONTS.sizes.md};
    font-family: ${FONTS.families.bold};
    font-weight: ${FONTS.weights.bold};
    color: ${COLORS.secondary.darkBlue.primary};
  `,
  paragraphBoldLarge: css`
    font-size: ${FONTS.sizes.lg};
    font-family: ${FONTS.families.bold};
    font-weight: ${FONTS.weights.bold};
    color: ${COLORS.secondary.darkBlue.primary};
  `,
  paragraph2: css`
    font-size: ${FONTS.sizes.sm};
    font-family: ${FONTS.families.regular};
    color: ${COLORS.secondary.darkBlue.primary};
  `,
  paragraphBold2: css`
    font-size: ${FONTS.sizes.sm};
    font-family: ${FONTS.families.bold};
    font-weight: ${FONTS.weights.bold};
    color: ${COLORS.secondary.darkBlue.primary};
  `,
  caption: css`
    font-size: ${FONTS.sizes.xs};
    font-family: ${FONTS.families.regular};
    color: ${COLORS.secondary.darkBlue.primary};
  `,
  menu: css`
    font-size: ${FONTS.sizes.xs};
    font-family: ${FONTS.families.headlines.regular};
    color: ${COLORS.secondary.darkBlue.primary};
    text-transform: uppercase;
  `,
  label: css`
    font-size: ${FONTS.sizes.xs};
    font-family: ${FONTS.families.headlines.bold};
    font-weight: ${FONTS.weights.bold};
    color: ${COLORS.secondary.darkBlue.primary};
    text-transform: uppercase;
  `,
  graphCaption: css`
    font-size: ${FONTS.sizes.xxs};
    font-family: ${FONTS.families.regular};
    color: ${COLORS.greys.dark};
    text-transform: uppercase;
  `,
}
